import React from "react";
import styles from "./SliderSection.module.scss";

import SectionWrapper from "components/elements/SectionWrapper";
import Slider from "components/elements/Slider/Slider";
import TextSlider from "components/elements/TextSlider/TextSlider";

const SliderSection = (props) => {
    const { alignment, data } = props;

    return (
        <div className={`text-${alignment ? alignment : "left"}`}>
            <SectionWrapper 
                className={`${styles.SliderSection}`} 
                fluid={false} 
                {...props}
            >
                <div className="mx-n3 mx-sm-0">
                    {data && data.length > 0 && data[0].mediaUrl ? (
                        <Slider slides={data} />
                    ) : (
                        <TextSlider slides={data} />
                    )}
                </div>
            </SectionWrapper>
        </div>
    );
};

export default SliderSection;
